module.exports = __webpack_public_path__ + "static/media/anytime-fitness.0a50e667.svg";